import { Suspense } from 'react';
import { Helmet } from "react-helmet";
import hand_phone_black_bg from '../../../images/hand_phone_black_bg.svg';
import tmobile_eero_light_mode_logo from '../../../images/T-Fiber-Light-mode-Logo.svg';
import tmobile_eero_dark_mode_logo from '../../../images/T-Fiber-Dark-mode-Logo.svg';
import { useTranslation } from 'react-i18next';
import {getAppOptions, AppType} from '../utils/app-options';
import { useDarkMode } from '../../../hooks/useDarkMode';

function TMobileInvitesApp() {
  const { t } = useTranslation();
  const isDarkMode = useDarkMode();
  const logoSrc = isDarkMode ? tmobile_eero_dark_mode_logo : tmobile_eero_light_mode_logo;

  const appOpt = getAppOptions(AppType.TMobileInvites);
  
  document.title = t("NETWORK_INVITES_TITLE");

  return (
    <div className="App tmobile">
      <Helmet>
        <meta name="description" content={ t("EERO_META_NETWORK_INVITES_DESCRIPTION") } />
        <meta name="og:title" content={ t("EERO_META_NETWORK_INVITES_OGTITLE") } />
        <meta name="og:description" content={ t("EERO_META_NETWORK_INVITES_OGDESCRIPTION") } />
      </Helmet>      
      { 
        appOpt.isDesktop 
        ? <div id="desktopView" style={{ visibility : "visible" }}>
            <img src={ logoSrc } className="logo-desktop" alt=""/>
            <h1 className="desktopText">{ t("OPEN_TRANSFER_LINK") }</h1>
            <img src={ hand_phone_black_bg } className="handPhone" alt=""/>
          </div>
        : <div id="mobileView" style={{ visibility : "visible" }}>
            <img src={ logoSrc } className="home" alt=""/>
            <a id="downloadLink" className="buttonHref" href={ appOpt.downloadLink }>
                <div className="button downloadButton">{ t("DOWNLOAD_APP") }</div>
            </a>
            <a id="openLink" className="buttonHref" href={ appOpt.openLink }>
                <div className="button openButton">{ t("OPEN_EERO_APP") }</div>
            </a>
          </div>
      }
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...is loading">
      <TMobileInvitesApp />
    </Suspense>
  );
}
